import Vue from 'vue';
import axios from 'axios';

axios.defaults.headers.common['X-Requested-With'] = "XMLHttpRequest";

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}

const app = new Vue({
    el: "#term",
    data: {
        area: "",
        country: "",
        startdate: startDate,
        enddate: endDate,
        areaResult: selection.area,
        countryResult: [],
    },
    methods:{
        changeArea: function(){
            this.country = "";
            axios.get(baseUrl, {
                params: {
                    area: this.area
                }
            }).then((response) => { 
                this.countryResult = response.data.data; 
                console.log(this.countryResult);
            }).catch(error => console.log(error));
        },
        changeCountry: function(){
            this.$refs.keyword.value = this.country;
            this.$refs.mobileForm.submit();
        },
        searchDate: function(){
            if (this.startdate <= this.enddate) this.$refs.mobileForm.submit();
        }
    }
});


// WEBPACK FOOTER //
// ./resources/assets/search.js